export const AUTH_METHODS = [
  'magic_link',
  'google',
  'apple',
  'microsoft',
] as const

export type AuthMethod = (typeof AUTH_METHODS)[number]
